module.exports = __webpack_public_path__ + "img/footer-logos.3105a858.svg";